import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import 'normalize.css';
import { Category, ThemeBar } from '../components';
import { Calculator, Favorites, FavoritesX, FavoritesY, MarketCap, Portfolio, Settings, Splash } from '../screens';
import { Theme } from '../constants';

class App extends Component {
  state = {
    theme: 'dracula',
  };

  componentDidMount() {
    const theme = localStorage.getItem('cmTheme');
    if (theme) this.setState({ theme });
  }

  selectTheme = (event) => {
    const theme = event.target.value;
    this.setState({ theme });
    localStorage.setItem('cmTheme', theme);
  };

  render() {
    const { theme } = this.state;
    const activeTheme = Theme[theme];
    return (
      <ThemeProvider theme={activeTheme}>
        <div>
          <ThemeBar selectTheme={this.selectTheme} selectedTheme={theme} />
          <Category title="Favorites">
            <Favorites />
            <FavoritesX />
            <FavoritesY />
          </Category>
          <Category title="Portfolio">
            <Portfolio />
          </Category>
          <Category title="Market Cap">
            <MarketCap />
          </Category>
          <Category title="Splash">
            <Splash />
          </Category>
          <Category title="Calculator">
            <Calculator />
          </Category>
          <Category title="Settings">
            <Settings />
          </Category>
          <ThemeBar selectTheme={this.selectTheme} selectedTheme={theme} />
        </div>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js